import { render, staticRenderFns } from "./IconSelect.vue?vue&type=template&id=1016b589&scoped=true&"
import script from "./IconSelect.vue?vue&type=script&lang=js&"
export * from "./IconSelect.vue?vue&type=script&lang=js&"
import style0 from "./IconSelect.vue?vue&type=style&index=0&id=1016b589&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1016b589",
  null
  
)

export default component.exports